import {
    isNull,
} from '@/utils/main'

const localState = {
    partners: null,
    partner: {
        name: null,
        email: null,
        phone: null,
        service_id: null,
    },
    addModal: false,
    deleteModal: false,
    isUpdate: false,
    deletedId: null,
    deletion_tag: false,
}

const mutations = {
    setPartners: (state, v) => {
        state.partners = v
    },
    setPartner: (state, v) => {
        state.partner.id = v.id
        state.partner.name = v.name
        state.partner.email = v.email
        state.partner.phone = v.phone
        state.partner.service_id = v.service_id
        state.partner.services = v.services
    },
    setDeletedId: (state, v) => {
        state.deletedId = v
    },
    setAddModal: (state) => {
        state.addModal = !state.addModal
    },
    setDeleteModal: (state) => {
        state.deleteModal = !state.deleteModal
    },
    clear: (state) => {
        state.addModal = false

        setTimeout(() => {
            state.isUpdate = false

            state.partner = {
                name: null,
                email: null,
                phone: null,
                service_id: null,
            }
        }, 1000)
    },
    changeIsUpdate: (state, v) => {
        state.isUpdate = v
    },
    setDeletionStatus: (state, v) => {
        state.deletion_tag = v
    },
}

const actions = {
    async fetch({
        commit,
    }, {
        search = null,
    }) {
        try {
            let query = ''
            if (!isNull(search)) query += `?search=${search}`

            const response = await this.$api.partners.fetch(query)
            commit('setPartners', response.data.data !== undefined ? response.data.data : [])
        } catch (err) {
            console.log(err)
        }
    },

    async remove({
        commit,
        state,
    }) {
        try {
            const response = await this.$api.partners.remove(state.deletedId)
            this.dispatch('partners/fetch', {})

            commit('setDeleteModal')
            return response.data
        } catch (err) {
            console.log(err)
        }
    },

    async create({
        state,
        commit,
    }) {
        try {
            if (state.partner.services.length > 0) delete state.partner.service_id
            const response = await this.$api.partners.create(state.partner)

            this.dispatch('partners/fetch', {})
            if (response.status === 201) {
                commit('clear')
            }
        } catch (err) {
            console.log(err)
        }
    },

    async edit({
        commit,
    }, id) {
        try {
            const response = await this.$api.partners.fetchById(id)

            commit('changeIsUpdate', true)
            commit('setPartner', response.data.data)
            commit('setAddModal')
            return response.data
        } catch (err) {
            console.log(err)
        }
    },

    async update({
        state,
        commit,
    }) {
        try {
            const { id } = state.partner
            const response = await this.$api.partners.update(id, state.partner)

            this.dispatch('partners/fetch', {})

            commit('clear')
            return response.data
        } catch (err) {
            console.log(err)
        }
    },
}

const getters = {
    partnersGetters: (state) => state.partners,
    partnerGetters: (state) => state.partner,
    addModal: (state) => state.addModal,
    isUpdateGetters: (state) => state.isUpdate,
    deleteModal: (state) => state.deleteModal,
    partnerDeleteId: (state) => state.deletedId,
    deletionStatusGetters: (state) => state.deletion_tag,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
